export enum RequestAggregatorMethod {
  Get = 'GET',
  Post = 'POST',
  Delete = 'DELETE',
  Put = 'PUT',
  Patch = 'PATCH',
}
